export default function WhyProfessional() {
  return (
    <section className="py-12 sm:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className="text-center mb-10 sm:mb-16">
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold text-[#1A2B4C] mb-4 sm:mb-6 leading-tight font-['Playfair_Display']">
            Почему важно заказать сайт именно у профессионала{' '}
            <span className="hidden sm:inline"><br /></span>
            <span className="text-[#C5A880]">(Маркетолога + Дизайнера)?</span>
          </h2>
          <p className="text-base sm:text-xl text-gray-700 max-w-4xl mx-auto leading-relaxed font-['Montserrat'] text-justify">
            Программисты делают сайты для браузеров. Мы делаем сайты для людей, которые принимают решение о покупке.
          </p>
          <p className="text-sm sm:text-lg text-gray-600 mt-3 sm:mt-4 max-w-4xl mx-auto italic font-['Montserrat'] text-justify">
            Заказать сайт у «просто программиста» — это как нанять каменщика построить дом без архитектурного плана. Он положит кирпичи, но в доме нельзя будет жить.
          </p>
        </div>

        {/* Three Cards */}
        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8 mb-8 sm:mb-12">
          {/* Card 1 */}
          <div className="bg-[#F8F9FA] rounded-3xl p-6 sm:p-8 border border-[#C5A880]/20 hover:shadow-xl transition-all duration-300">
            <div className="flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 bg-[#C5A880] rounded-full mb-5 sm:mb-6">
              <i className="ri-route-line text-2xl sm:text-3xl text-white"></i>
            </div>
            <h3 className="text-lg sm:text-xl font-bold text-[#1A2B4C] mb-3 sm:mb-4 font-['Playfair_Display']">
              Проектирование пути пользователя (UX)
            </h3>
            <p className="text-sm sm:text-base text-gray-700 leading-relaxed font-['Montserrat'] text-justify">
              Профессионал не рисует кнопки, он проектирует сценарии поведения. Он знает, куда посмотрит глаз клиента и какой аргумент должен встретить его на втором экране.
            </p>
          </div>

          {/* Card 2 */}
          <div className="bg-[#F8F9FA] rounded-3xl p-6 sm:p-8 border border-[#C5A880]/20 hover:shadow-xl transition-all duration-300">
            <div className="flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 bg-[#C5A880] rounded-full mb-5 sm:mb-6">
              <i className="ri-rocket-line text-2xl sm:text-3xl text-white"></i>
            </div>
            <h3 className="text-lg sm:text-xl font-bold text-[#1A2B4C] mb-3 sm:mb-4 font-['Playfair_Display']">
              Технологическое превосходство (SEO и Скорость)
            </h3>
            <p className="text-sm sm:text-base text-gray-700 leading-relaxed font-['Montserrat'] text-justify">
              Современный сайт — это сложный механизм. Профессионал сделает так, чтобы Google и Яндекс «любили» ваш сайт. Каждая секунда задержки — это -7% конверсии.
            </p>
          </div>

          {/* Card 3 */}
          <div className="bg-[#F8F9FA] rounded-3xl p-6 sm:p-8 border border-[#C5A880]/20 hover:shadow-xl transition-all duration-300 sm:col-span-2 md:col-span-1">
            <div className="flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 bg-[#C5A880] rounded-full mb-5 sm:mb-6">
              <i className="ri-line-chart-line text-2xl sm:text-3xl text-white"></i>
            </div>
            <h3 className="text-lg sm:text-xl font-bold text-[#1A2B4C] mb-3 sm:mb-4 font-['Playfair_Display']">
              Масштабируемость
            </h3>
            <p className="text-sm sm:text-base text-gray-700 leading-relaxed font-['Montserrat'] text-justify">
              Грамотный сайт строится «на вырост». Профессионал заложит возможность интеграции с CRM, системами аналитики и сервисами рассылок.
            </p>
          </div>
        </div>

        {/* Main Argument */}
        <div className="bg-gradient-to-br from-[#1A2B4C] to-[#2A3B5C] rounded-3xl p-6 sm:p-10 text-center border-2 border-[#C5A880]">
          <div className="flex items-center justify-center w-16 h-16 sm:w-20 sm:h-20 bg-[#C5A880] rounded-full mb-5 sm:mb-6 mx-auto">
            <i className="ri-medal-line text-3xl sm:text-4xl text-white"></i>
          </div>
          <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-white mb-3 sm:mb-4 font-['Playfair_Display']">
            Главный аргумент для бизнеса
          </h3>
          <p className="text-base sm:text-xl text-white/90 leading-relaxed max-w-4xl mx-auto font-['Montserrat'] text-justify">
            Веб-сайт — это единственный сотрудник, который не спит, не болеет, одновременно общается с тысячей клиентов и всегда говорит им именно то, что вы хотите, в лучшем виде.
          </p>
        </div>
      </div>
    </section>
  );
}